<template>
  <router-view/>
</template>

<style lang="scss">
*{
  margin:0;
  padding:0
}

::-webkit-scrollbar{
  width: 5px;
  height: 5px;
  position: absolute;
}

::-webkit-scrollbar-thumb{
  background:#1890ff;
}

::-webkit-scrollbar-track{
  background:#ddd;
}

// ====================== 全局 Dialog 暗黑主题（🔥 新增 ） ======================
.el-dialog {
  background-color: #0F1419 !important;
  /* 统一深色背景 */
  border: 1px solid #2d2d3f !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4) !important;
  border-radius: 8px !important;
  overflow: hidden;
}

/* Dialog 头部 */
.el-dialog__header {
  border-bottom: 1px solid #2d2d3f !important;
  padding: 16px 24px;
  background-color: #0F1419 !important;
}

/* Dialog 标题 */
.el-dialog__title {
  color: #ffffff !important;
  font-size: 16px;
  font-weight: 500;
}

/* Dialog 关闭按钮 */
.el-dialog__headerbtn .el-dialog__close {
  color: #a8b2d3 !important;
  font-size: 16px;
}

.el-dialog__headerbtn:hover .el-dialog__close {
  color: #1890ff !important;
}

/* Dialog 内容区域 */
.el-dialog__body {
  background-color: #0F1419 !important;
  color: #e5eaf3 !important;
  padding: 24px;
}

/* Dialog 底部按钮区域 */
.el-dialog__footer {
  border-top: 1px solid #2d2d3f !important;
  padding: 16px 24px;
  text-align: right;
  background-color: #0F1419 !important;
}

/* Dialog 底部按钮样式 */
/* 取消按钮 */
.el-dialog__footer .el-button--default {
  background-color: #2d2d3f !important;
  border-color: #3b3b5b !important;
  color: #e5eaf3 !important;
}

.el-dialog__footer .el-button--default:hover {
  background-color: #3b3b5b !important;
  border-color: #4c4c63 !important;
  color: #ffffff !important;
}

/* 确认/主按钮 */
.el-dialog__footer .el-button--primary {
  background-color: #1890ff !important;
  border-color: #1890ff !important;
  color: #ffffff !important;
}

.el-dialog__footer .el-button--primary:hover {
  background-color: #40a9ff !important;
  border-color: #40a9ff !important;
}

// 达人管理列表统一暗色主题
.admin-list-card.el-card {
  --el-card-bg-color: rgba(13, 21, 34, 0.94);
  --el-card-border-color: #26364b;
  background: rgba(13, 21, 34, 0.94) !important;
  border-color: #26364b !important;
  color: #d8e3f1;
  box-shadow: none;
  backdrop-filter: blur(14px);
}

.admin-list-card .el-card__header {
  color: #eef5ff;
  background: rgba(20, 31, 48, 0.82);
  border-bottom-color: #26364b;
}

.admin-list-card .el-form-item__label {
  color: #aebdd0;
}

.admin-list-card .el-input__wrapper,
.admin-list-card .el-select__wrapper,
.admin-list-card .el-date-editor.el-input__wrapper {
  background: rgba(17, 27, 42, 0.94) !important;
  box-shadow: 0 0 0 1px #31445e inset !important;
}

.admin-list-card .el-input__inner,
.admin-list-card .el-range-input,
.admin-list-card .el-range-separator {
  color: #dce7f5 !important;
}

.admin-list-card .el-table {
  --el-table-bg-color: transparent;
  --el-table-tr-bg-color: rgba(13, 22, 36, 0.9);
  --el-table-header-bg-color: #172438;
  --el-table-row-hover-bg-color: #1b2c43;
  --el-table-border-color: #2a3b52;
  --el-table-text-color: #cad6e6;
  --el-table-header-text-color: #9fb0c6;
  background: transparent !important;
}

.admin-list-card .el-table__inner-wrapper::before {
  background-color: #2a3b52;
}

.admin-list-card .el-table__empty-block {
  background: rgba(13, 22, 36, 0.9);
}

.admin-list-card .el-pagination {
  --el-pagination-bg-color: #142033;
  --el-pagination-button-disabled-bg-color: #0e1725;
  --el-pagination-text-color: #bdcadb;
  --el-pagination-button-color: #bdcadb;
}

</style>
